(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.blog-post-content a').forEach(function(link) {
    if (link.textContent.includes('catalogue de boosters')) {
      link.classList.add('btn-holo', 'article-content-cta-link');
      var wrap = document.createElement('div');
      wrap.className = 'article-content-cta-wrap';
      link.parentNode.insertBefore(wrap, link);
      wrap.appendChild(link);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
